import React, { useState, useEffect,useRef } from 'react';
import { useParams } from "react-router-dom";

import { 
  CheckCircle2,
  Award,
  Clock,
  Users,
  ArrowRight,
  Phone,
  Mail,
  ChevronDown,
  ChevronUp,
  Star,
  Shield,
  Zap,
  Target,
  Settings,
  Package,
  TrendingUp
} from 'lucide-react';
import Header from "../Header";
import Footer from "../Footer";
import api from '../api/Api';

export default function ServiceViewPage({ isDarkMode, setIsDarkMode }) {
    const { code } = useParams();
    const hasFetched = useRef(false);
    const [serviceData, setServiceData] = useState(null);
const [loading, setLoading] = useState(true);
    const URL_BASE ='https://api.angonet.ao/public/img/servicos/';
//const URL_BASE = 'http://127.0.0.1:8000/storage/img/servicos/';



useEffect(() => {
  document.title = "Serviços";
  if (!code) return;

  const fetchService = async () => {
    try {
      setLoading(true);

      const response = await api.ListServico({
        code: code
      });

      if (response && response.length > 0) {
        const data = response[0];

        // Transformar para o formato que a página espera
        setServiceData({
          id: data.id,
          title: data.titulo,
          category: data.categoria,
          shortDescription: data.subtitulo,
          fullDescription: data.descricao,
          mainImage: `${URL_BASE}${data.img}`,
          price: data.modalidade,
          duration: data.periodo_instalacao,
          warranty: "Sob consulta",

          features: data.funcionalidades?.map(item => ({
            icon: Shield, // depois podemos mapear dinamicamente
            title: item.descricao,
            description: item.descricao
          })) || [],

          benefits: data.beneficios?.map(item => item.descricao) || [],

          processSteps: data.processos?.map((item, index) => ({
            step: index + 1,
            title: item.descricao,
            description: item.descricao,
            duration: ""
          })) || [],

          includes: data.funcionalidades?.map(item => item.descricao) || [],

          technologies: [],

          faqs: data.faqs?.map(item => ({
            question: item.pergunta,
            answer: item.resposta
          })) || []
        });
      }

    } catch (error) {
      console.error("Erro ao buscar serviço:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchService();

}, [code]);



  const [activeTab, setActiveTab] = useState('overview');
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
 

  const handleSubmit = (e) => {
    e.preventDefault();
    
   
    setFormData({ name: '', email: '', phone: '', company: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };


if (loading) {
  return (
    <div className={`min-h-screen flex items-center justify-center relative overflow-hidden ${
      isDarkMode ? 'bg-gray-900' : 'bg-white'
    }`}>
      
      {/* Background Glow */}
      <div className={`absolute top-0 right-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
        isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
      }`} />
      
      <div className={`absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full blur-[120px] animate-pulse ${
        isDarkMode ? 'bg-purple-500/10' : 'bg-purple-400/20'
      }`} />

      {/* Loader Content */}
      <div className="relative z-10 text-center">
        
        {/* Gradient Spinner */}
        <div className="relative w-20 h-20 mx-auto mb-6">
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 border-r-purple-600 animate-spin"></div>
          <div className={`absolute inset-2 rounded-full ${
            isDarkMode ? 'bg-gray-900' : 'bg-white'
          }`}></div>
        </div>

        {/* Text */}
        <h2 className={`text-2xl font-bold mb-2 ${
          isDarkMode ? 'text-white' : 'text-gray-900'
        }`}>
          Carregando Serviço
        </h2>

        <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
          Estamos preparando as informações para você...
        </p>

        {/* Animated Dots */}
        <div className="flex justify-center mt-4 space-x-2">
          <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></span>
          <span className="w-2 h-2 bg-purple-500 rounded-full animate-bounce delay-150"></span>
          <span className="w-2 h-2 bg-cyan-500 rounded-full animate-bounce delay-300"></span>
        </div>
      </div>
    </div>
  );
}



  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Animated Background Particles */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`} style={{animationDelay: '1s'}}></div>
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-[100px] animate-pulse ${
          isDarkMode ? 'bg-cyan-500/5' : 'bg-cyan-400/15'
        }`} style={{animationDelay: '2s'}}></div>
        
        {/* Floating particles */}
        <div className="absolute top-[20%] left-[15%] w-1 h-1 bg-blue-500 rounded-full animate-float"></div>
        <div className="absolute top-[40%] right-[20%] w-1.5 h-1.5 bg-cyan-500 rounded-full animate-float" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-[60%] left-[30%] w-1 h-1 bg-purple-500 rounded-full animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-[80%] right-[40%] w-2 h-2 bg-blue-400 rounded-full animate-float" style={{animationDelay: '0.5s'}}></div>
      </div>

      <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

      {/* Hero Section */}
      <section className="relative pt-20">
        <div className="relative h-[500px] overflow-hidden">
          <img
            src={serviceData.mainImage}
            alt={serviceData.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
          
          <div className="absolute inset-0 flex items-end">
            <div className="max-w-7xl mx-auto w-full px-6 pb-12">
              <div className="max-w-3xl">
                <div className="inline-block px-4 py-2 bg-blue-600/80 backdrop-blur-sm rounded-full text-white text-sm font-semibold mb-4">
                  {serviceData.category}
                </div>
                <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
                  {serviceData.title}
                </h1>
                <p className="text-xl text-gray-200 mb-6">
                  {serviceData.shortDescription}
                </p>
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center space-x-2 text-white">
                    <Clock size={20} />
                    <span className="text-sm">{serviceData.duration}</span>
                  </div>
        
                  <div className="flex items-center space-x-2 text-white">
                    <Target size={20} />
                    <span className="text-sm">{serviceData.price}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Left Content */}
            <div className="lg:col-span-2 space-y-12">
              {/* Tabs Navigation */}
              <div className={`flex flex-wrap gap-2 border-b ${
                isDarkMode ? 'border-white/10' : 'border-gray-200'
              }`}>
                <button
                  onClick={() => setActiveTab('overview')}
                  className={`px-6 py-3 font-semibold transition-all ${
                    activeTab === 'overview'
                      ? isDarkMode
                        ? 'border-b-2 border-cyan-400 text-cyan-400'
                        : 'border-b-2 border-blue-600 text-blue-600'
                      : isDarkMode
                      ? 'text-gray-400 hover:text-gray-300'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Visão Geral
                </button>
                <button
                  onClick={() => setActiveTab('process')}
                  className={`px-6 py-3 font-semibold transition-all ${
                    activeTab === 'process'
                      ? isDarkMode
                        ? 'border-b-2 border-cyan-400 text-cyan-400'
                        : 'border-b-2 border-blue-600 text-blue-600'
                      : isDarkMode
                      ? 'text-gray-400 hover:text-gray-300'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Processo
                </button>
                <button
                  onClick={() => setActiveTab('includes')}
                  className={`px-6 py-3 font-semibold transition-all ${
                    activeTab === 'includes'
                      ? isDarkMode
                        ? 'border-b-2 border-cyan-400 text-cyan-400'
                        : 'border-b-2 border-blue-600 text-blue-600'
                      : isDarkMode
                      ? 'text-gray-400 hover:text-gray-300'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Funcionalidades
                </button>
              </div>

              {/* Tab Content: Overview */}
              {activeTab === 'overview' && (
                <div className="space-y-8">
                  {/* Description */}
                  <div>
                    <h2 className={`text-3xl font-bold mb-4 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}>
                      Sobre o Serviço
                    </h2>
                    <p className={`text-lg leading-relaxed ${
                      isDarkMode ? 'text-gray-400' : 'text-gray-600'
                    }`}>
                      {serviceData.fullDescription}
                    </p>
                  </div>

                  {/* Features Grid */}
                  <div>
                    <h3 className={`text-2xl font-bold mb-6 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}>
                      Características Principais
                    </h3>
                    <div className="grid md:grid-cols-2 gap-6">
                      {serviceData.features.map((feature, index) => {
                        const Icon = feature.icon;
                        return (
                          <div
                            key={index}
                            className={`p-6 rounded-xl ${
                              isDarkMode
                                ? 'bg-gray-800 border border-white/10'
                                : 'bg-gray-50 border border-gray-200'
                            }`}
                          >
                            <div className="flex items-start space-x-4">
                              <div className="flex-shrink-0 p-3 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg">
                                <Icon size={24} className="text-white" />
                              </div>
                              <div>
                                <h4 className={`font-bold mb-2 ${
                                  isDarkMode ? 'text-white' : 'text-gray-900'
                                }`}>
                                  {feature.title}
                                </h4>
                                <p className={`text-sm ${
                                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                                }`}>
                                  {feature.description}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Benefits */}
                  <div>
                    <h3 className={`text-2xl font-bold mb-6 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}>
                      Benefícios
                    </h3>
                    <div className="grid md:grid-cols-2 gap-4">
                      {serviceData.benefits.map((benefit, index) => (
                        <div key={index} className="flex items-start space-x-3">
                          <CheckCircle2 size={20} className="text-green-500 flex-shrink-0 mt-1" />
                          <span className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                            {benefit}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Technologies */}
                  <div>
                    <h3 className={`text-2xl font-bold mb-6 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}>
                      Tecnologias Utilizadas
                    </h3>
                    <div className="flex flex-wrap gap-3">
                      {serviceData.technologies.map((tech, index) => (
                        <span
                          key={index}
                          className={`px-4 py-2 rounded-full text-sm font-medium ${
                            isDarkMode
                              ? 'bg-gray-800 text-cyan-400 border border-white/10'
                              : 'bg-blue-50 text-blue-700 border border-blue-200'
                          }`}
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Tab Content: Process */}
              {activeTab === 'process' && (
                <div>
                  <h2 className={`text-3xl font-bold mb-6 ${
                    isDarkMode ? 'text-white' : 'text-gray-900'
                  }`}>
                    Nosso Processo
                  </h2>
                  <div className="space-y-6">
                    {serviceData.processSteps.map((step, index) => (
                      <div
                        key={index}
                        className={`relative p-6 rounded-xl ${
                          isDarkMode
                            ? 'bg-gray-800 border border-white/10'
                            : 'bg-white border border-gray-200 shadow-lg'
                        }`}
                      >
                        <div className="flex items-start space-x-6">
                          <div className="flex-shrink-0">
                            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center text-white font-bold text-xl">
                              {step.step}
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-start justify-between mb-2">
                              <h4 className={`text-xl font-bold ${
                                isDarkMode ? 'text-white' : 'text-gray-900'
                              }`}>
                                {step.title}
                              </h4>
                              <span className={`text-sm px-3 py-1 rounded-full ${
                                isDarkMode
                                  ? 'bg-gray-700 text-gray-300'
                                  : 'bg-gray-100 text-gray-600'
                              }`}>
                                {step.duration}
                              </span>
                            </div>
                            <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                              {step.description}
                            </p>
                          </div>
                        </div>
                        
                        {/* Connecting Line */}
                        {index < serviceData.processSteps.length - 1 && (
                          <div className={`absolute left-[3rem] top-[4.5rem] bottom-[-1.5rem] w-0.5 ${
                            isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
                          }`}></div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Tab Content: Includes */}
              {activeTab === 'includes' && (
                <div>
                  <h2 className={`text-3xl font-bold mb-6 ${
                    isDarkMode ? 'text-white' : 'text-gray-900'
                  }`}>
                    O que Está Incluído
                  </h2>
                  <div className="grid md:grid-cols-2 gap-4">
                    {serviceData.includes.map((item, index) => (
                      <div
                        key={index}
                        className={`flex items-center space-x-3 p-4 rounded-lg ${
                          isDarkMode ? 'bg-gray-800' : 'bg-gray-50'
                        }`}
                      >
                        <CheckCircle2 size={20} className="text-green-500 flex-shrink-0" />
                        <span className={isDarkMode ? 'text-gray-300' : 'text-gray-700'}>
                          {item}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* FAQs */}
              <div>
                <h2 className={`text-3xl font-bold mb-6 ${
                  isDarkMode ? 'text-white' : 'text-gray-900'
                }`}>
                  Perguntas Frequentes
                </h2>
                <div className="space-y-4">
                  {serviceData.faqs.map((faq, index) => (
                    <div
                      key={index}
                      className={`rounded-xl overflow-hidden ${
                        isDarkMode
                          ? 'bg-gray-800 border border-white/10'
                          : 'bg-white border border-gray-200 shadow-lg'
                      }`}
                    >
                      <button
                        onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                        className={`w-full p-6 text-left flex items-center justify-between ${
                          isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'
                        } transition-colors`}
                      >
                        <span className={`font-semibold ${
                          isDarkMode ? 'text-white' : 'text-gray-900'
                        }`}>
                          {faq.question}
                        </span>
                        {expandedFaq === index ? (
                          <ChevronUp className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'} size={20} />
                        ) : (
                          <ChevronDown className={isDarkMode ? 'text-gray-400' : 'text-gray-600'} size={20} />
                        )}
                      </button>
                      {expandedFaq === index && (
                        <div className={`px-6 pb-6 ${
                          isDarkMode ? 'text-gray-400' : 'text-gray-600'
                        }`}>
                          {faq.answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              
            </div>

            {/* Right Sidebar - Quote Form */}
            
          </div>
        </div>
      </section>

      

      <Footer isDarkMode={isDarkMode} />

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}